<template>
  <div>
    <ContentHeader />
    <ElCollapse accordion>
      <CollapseItem
        v-for="item in jobList"
        :id="item.jobId"
        :name="item.jobName"
        :date="item.publishTime"
        :location="item.city"
        :text="item.detail"
        :key="item.jobId"
        :educationRequired="item.educationRequired"
        :new-flag="isHasNewFlag(item)"
      />
    </ElCollapse>
    <!-- 空记录 -->
    <div v-if="!jobList.length" class="job-empty-content">
      <img src="../../assets/empty.png" />
      <p>搜索无结果~</p>
    </div>
    <ElPagination
      v-if="jobList.length"
      class="job-pagination"
      background
      layout="prev, pager, next"
      :page="Number(page)"
      :total="total"
      @currentChange="currentChange">
    </ElPagination>
  </div>
</template>

<script lang="ts" setup>
import dayjs from 'dayjs'
import { request } from '../../api/request';

import { onMounted, watch, ref, defineProps } from 'vue'
// 组件
import { ElCollapse, ElPagination } from 'element-plus';
import ContentHeader from './content-header.vue';
import CollapseItem from './collapse-item.vue'

const props = defineProps<{ city: string, jobName: string }>()

const jobList = ref([])
const page = ref(1)
const total = ref(0)

/** 监听 */
watch(
  () => props.city,
  () => {
    page.value = 1
    getJobList()
  }
)

watch(
  () => props.jobName,
  () => {
    page.value = 1
    getJobList()
  }
)

const getJobList = async () => {
  try {
    const params = {
      jobName: props.jobName || '',
      city: props.city || '全国',
      page: page.value,
      pageSize: 10
    }
    const res = await request("web.cms.pcWeb.query.job", params)
    console.log(res, 'job-list')
    jobList.value = res?.rows || []
    total.value = res?.rowTotal || 0
  } catch (e) {
    console.log(e)
  }
}

const currentChange = (val) => {
  page.value = +val
  console.log(val, 'currentChange')
  getJobList()
}

// 计算是否近3天发布的职位
const isHasNewFlag = (item) => {
  const today = dayjs()
  const targetDate = dayjs(item.publishTime)
  const diffInDays = today.diff(targetDate, 'day')
  console.log('diffInDays', diffInDays)
  return diffInDays <= 3
}

onMounted(() => {
  getJobList()
})
</script>

<style>
.job-pagination {
  display: flex;
  justify-content: right;
  margin: 80px 0 30px;
}
.job-empty-content {
  text-align: center;
  color: #666666;
  font-size: 14px;
  img {
    width: 120px;
    height: 120px;
    display: block;
    margin: 60px auto 8px;
  }
  p {
    margin: 0;
  }
}
.el-pagination.is-background .btn-next.is-active, .el-pagination.is-background .btn-prev.is-active, .el-pagination.is-background .el-pager li.is-active {
  background-color: #7E51E4;
  &:hover {
    color: #fff;
  }
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  &:hover {
    color: #7E51E4;
  }
}
.el-pagination.is-background .btn-next.is-disabled, .el-pagination.is-background .btn-next:disabled, .el-pagination.is-background .btn-prev.is-disabled, .el-pagination.is-background .btn-prev:disabled, .el-pagination.is-background .el-pager li.is-disabled, .el-pagination.is-background .el-pager li:disabled {
  &:hover {
    color: #a8abb2;
  }
}
</style>
